(() => {
	// navbar sticky
	// console.log("hello i am from navbar");
	const common = ["top-0", "left-0", "right-0", "mx-auto"];
	const stickyNav = [
		"fixed",
		...common,
		"bg-white",
		"dark:bg-dark",
		"shadow-default",
		"py-3",
	];
	const staticNav = ["absolute", ...common, "bg-transparent", "py-5"];

	document.querySelectorAll(".navbar").forEach((navbar) => {
		const navVersion = navbar.dataset.navbarVersion;
		const navPosition = navbar.dataset.positionStyle;

		if (navPosition === "sticky") {
			navbar.classList.add("absolute", ...common);

			window.addEventListener("scroll", () => {
				const currentScroll = window.pageYOffset;

				if (navVersion === "v1") {
					// JS for Navbar Version 1
					if (currentScroll > 100) {
						navbar.classList.remove(...staticNav);
						navbar.classList.add(...stickyNav);
					}
					if (currentScroll === 0) {
						navbar.classList.remove(...stickyNav);
						navbar.classList.add(...staticNav);
					}
				} else {
					// JS for Navbar Version 2

					if (currentScroll > 100) {
						navbar.classList.remove(...staticNav);
						navbar.classList.add(...stickyNav);

						// Search box style handle
						navbar
							.querySelectorAll(".search-box")
							.forEach((search) => {
								const input =
									search.getElementsByTagName("input")[0];
								const svg =
									search.getElementsByTagName("svg")[0];
								input.classList.remove(
									"text-primary-100",
									"placeholder:text-primary-100"
								);
								input.classList.add(
									"text-gray-700",
									"placeholder:text-gray-700"
								);
								svg.classList.remove("fill-primary-100");
								svg.classList.add("fill-gray-700");
							});

						// Nav link text style handle
						navbar
							.querySelectorAll(".nav-text")
							.forEach((textItem) => {
								textItem.classList.remove(
									"text-white",
									"hover:text-gray-300",
									"dark:hover:text-gray-300"
								);
								textItem.classList.add(
									"text-gray-900",
									"hover:text-primary-500",
									"dark:hover:text-primary-500"
								);

								textItem
									.querySelectorAll("svg")
									.forEach((svgItem) => {
										svgItem.classList.remove(
											"fill-white",
											"group-hover:fill-gray-300"
										);
										svgItem.classList.add(
											"fill-gray-900",
											"group-hover:fill-primary-500"
										);
									});
							});

						// Nav link icon button style handle
						navbar
							.querySelectorAll(".svg-button")
							.forEach((svgButton) => {
								svgButton.classList.replace(
									"hover:border-gray-500",
									"hover:border-primary-500"
								);
								svgButton
									.querySelectorAll("svg")
									.forEach((svgItem) => {
										svgItem.classList.remove(
											"fill-white",
											"group-hover:fill-gray-300"
										);
										svgItem.classList.add(
											"fill-gray-700",
											"group-hover:fill-primary-500"
										);
									});
							});
					}
					if (currentScroll === 0) {
						navbar.classList.remove(...stickyNav);
						navbar.classList.add(...staticNav);

						// Search box style handle
						navbar
							.querySelectorAll(".search-box")
							.forEach((search) => {
								const input =
									search.getElementsByTagName("input")[0];
								const svg =
									search.getElementsByTagName("svg")[0];
								input.classList.add(
									"text-primary-100",
									"placeholder:text-primary-100"
								);
								input.classList.remove(
									"text-gray-700",
									"placeholder:text-gray-700"
								);
								svg.classList.add("fill-primary-100");
								svg.classList.remove("fill-gray-700");
							});

						// Nav link text  style handle
						navbar
							.querySelectorAll(".nav-text")
							.forEach((textItem) => {
								textItem.classList.add(
									"text-white",
									"hover:text-gray-300",
									"dark:hover:text-gray-300"
								);
								textItem.classList.remove(
									"text-gray-900",
									"hover:text-primary-500",
									"dark:hover:text-primary-500"
								);

								textItem
									.querySelectorAll("svg")
									.forEach((svgItem) => {
										svgItem.classList.add(
											"fill-white",
											"group-hover:fill-gray-300"
										);
										svgItem.classList.remove(
											"fill-gray-900",
											"group-hover:fill-primary-500"
										);
									});
							});

						// Nav link icon button style handle
						navbar
							.querySelectorAll(".svg-button")
							.forEach((svgButton) => {
								svgButton.classList.replace(
									"hover:border-primary-500",
									"hover:border-gray-500"
								);
								svgButton
									.querySelectorAll("svg")
									.forEach((svgItem) => {
										svgItem.classList.add(
											"fill-white",
											"group-hover:fill-gray-300"
										);
										svgItem.classList.remove(
											"fill-gray-700",
											"group-hover:fill-primary-500"
										);
									});
							});
					}
				}
			});
		}
	});
})();
